//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export interface ILinkItem
{
    attributes?: { [key:string]: string };
    text: string;
    href: string;
    target?: string;
    title?: string;
}
export enum CampaignBlock_EditorTheme {
    None = 0,
    Dark = 1,
    Np = 2
}
export enum ContentAreaItem_Size {
    None = 0,
    FullScreen = 1,
    Half = 2,
    Third = 3,
    Quarter = 4,
    TwoThirds = 5
}
export enum DateCardMedia_Items_Icon {
    Slideshow = 0,
    Video = 1,
    Camera = 2
}
export enum DateCardStatus_Theme {
    None = 0,
    IsActive = 1,
    IsCompleted = 2,
    ResultIsPublished = 3,
    IsCanceled = 4,
    IsPlanned = 5
}
export enum DocumentIcon_IconTheme {
    None = 0,
    Word = 1,
    Pdf = 2,
    Ppt = 3,
    Excel = 4,
    Fallback = 5,
    Csv = 6,
    Image = 7
}
export enum EducationBlock_EditorTheme {
    None = 0,
    Blue = 1,
    Yellow = 2
}
export enum EventImage_Background {
    None = 0,
    Background1 = 1,
    Background2 = 2,
    Background3 = 3,
    Background4 = 4
}
export enum EventPageLink_Icon {
    Video = 0,
    Calendar = 1
}
export enum FrontpageHeader_EditorTheme {
    None = 0,
    Yellow = 1,
    Red = 2,
    Esaki = 3,
    Marconi = 4,
    Alfven = 5
}
export enum IconWarning_Theme {
    None = 0,
    Red = 1,
    Blue = 2,
    Gray = 3
}
export enum FetchPrioritySelector {
    Default = 0,
    High = 1
}
export enum ImageWithCaption_EditorTheme {
    None = 0,
    HalfWidth = 1
}
export enum LinkWithText_Theme {
    None = 0,
    Gray = 1,
    Prominent = 2
}
export enum ListItemImage_Size {
    None = 0,
    SmallImage = 1
}
export enum PortfolioTile_Theme {
    None = 0,
    Education = 1,
    Technologies = 2,
    Democracy = 3,
    Industry = 4,
    Food = 5,
    Welfare = 6,
    Health = 7,
    Climate = 8,
    Petroleum = 9,
    Humanities = 10,
    Science = 11,
    Nature = 12,
    Energy = 13,
    Global = 14,
    Ocean = 15,
    Sami = 16
}
export enum RelatedContent_Border {
    None = 0,
    Top = 1,
    Bottom = 2
}
export enum SatelliteHeader_TextColor {
    None = 0,
    Light = 1
}
export enum SearchResultGroup_IconName {
    None = 0,
    Mail = 1,
    Document = 2
}
export enum ShareOptions_Items_Icon {
    None = 0,
    Facebook = 1,
    Linkedin = 2,
    Mail = 4
}
export enum SocialMediaLink_Provider {
    None = 0,
    Facebook = 1,
    Linkedin = 2,
    Rss = 3,
    Instagram = 4
}
export enum Status_Theme {
    None = 0,
    IsActive = 1,
    IsCompleted = 2,
    ResultIsPublished = 3,
    IsCanceled = 4,
    IsPlanned = 5
}
export interface IAccordion extends IReactComponent
{
    collapseLabel: string;
    expandLabel: string;
    guid: string;
    initiallyOpen: boolean;
}
export interface IAccordionBlock extends IReactComponent
{
    accordion: IAccordion;
    onPageEditing?: IAccordionBlock_OnPageEditing;
    title: string;
    text: IRichText;
}
export interface IAccordionBlock_OnPageEditing
{
    title: string;
}
export interface IAccordionListBlock extends IReactComponent
{
    list: IFactBox[];
    title?: string;
    onPageEditing?: IAccordionListBlock_OnPageEditing;
}
export interface IAccordionListBlock_OnPageEditing
{
    title: string;
}
export interface IAccordionWithContentArea extends IReactComponent
{
    content?: IContentArea;
    accordion: IAccordion;
    onPageEditing?: IAccordionWithContentArea_OnPageEditing;
    title?: string;
    iconWarning?: IIconWarning;
    share: IOptionsModal;
    htmlId?: string;
    initiallyOpen: boolean;
}
export interface IAccordionWithContentArea_OnPageEditing
{
    title?: string;
}
export interface IAccordionWithContentAreaList extends IReactComponent
{
    content: IAccordionWithContentArea[];
    description?: string;
    htmlId: string;
    onPageEditing?: IAccordionWithContentAreaList_OnPageEditing;
    richText?: IRichText;
    title?: string;
    themeTags?: string[];
    text?: string;
}
export interface IAccordionWithContentAreaList_OnPageEditing
{
    title: string;
}
export interface IAnnouncement extends IReactComponent
{
    title: string;
    subTitle: string;
    groupTag?: string;
    links: ILink[];
}
export interface IArticleBlock extends IReactComponent
{
    byline?: IByline;
    title: ILink;
    image?: IImage;
    text?: string;
    published?: IPublished;
    linkTags?: ITagLinkList;
    tags?: ITagList;
    usedInSidebar: boolean;
    metadata?: IMetadata;
    icon?: IDocumentIcon;
    documentImage?: IImage;
    eventImage?: IEventImage;
}
export interface IArticleCardList extends IReactComponent
{
    list: ICard[];
}
export interface IArticleHeader extends IReactComponent
{
    accordion?: IAccordion;
    byline: IByline;
    links?: ILink[];
    share?: IOptionsModal;
}
export interface IArticlePage extends IReactComponent
{
    content: IRichText;
    footer: IPageFooter;
    header: IArticleHeader;
    ingress?: string;
    onPageEditing?: IArticlePage_OnPageEditing;
    sidebar: IContentArea;
    title?: string;
    image?: IImageWithCaption;
    hasLargeTitle: boolean;
}
export interface IArticlePage_OnPageEditing
{
    ingress: string;
    title: string;
}
export interface IAudioPlayer extends IReactComponent
{
    url: string;
    labels: IAudioPlayer_Labels;
    altText: string;
}
export interface IAudioPlayer_Labels
{
    play: string;
    download: string;
    pause: string;
}
export interface IBreadcrumbs extends IReactComponent
{
    accordion: IAccordion;
    currentPage?: string;
    items: ILink[];
    translationLabel?: string;
    root: ILink;
}
export interface IButton extends IReactComponent
{
    id?: string;
    text?: string;
    title?: string;
}
export interface IButtonInfoBlock extends IReactComponent
{
    buttonText: string;
    useChatbot: boolean;
    buttonTarget: string;
    onPageEditing?: IButtonInfoBlock_OnPageEditing;
    title?: string;
    text?: IRichText;
}
export interface IButtonInfoBlock_OnPageEditing
{
    title: string;
    text: IRichText;
}
export interface IByline extends IReactComponent
{
    items: IByline_Items[];
}
export interface IByline_Items
{
    onPageEditing?: string;
    text: string;
}
export interface ICampaignBlock extends IReactComponent
{
    cta: ILink;
    editorTheme: CampaignBlock_EditorTheme;
    image?: IImage;
    onPageEditing?: ICampaignBlock_OnPageEditing;
    title: string;
    description?: string;
    isProminent: boolean;
}
export interface ICampaignBlock_OnPageEditing
{
    title: string;
}
export interface ICampaignBlockList extends IReactComponent
{
    list: ICampaignBlock[];
}
export interface ICard extends IReactComponent
{
    link?: ILink;
    image?: IImage;
    eventImage?: IEventImage;
    preTitle?: string;
    title: string;
    text?: string;
    imageTag?: string;
    dataTagList?: string[];
    isPriority: boolean;
}
export interface ICarousel extends IReactComponent
{
    nextLabel?: string;
    previousLabel?: string;
}
export interface ICategoryListItem extends IReactComponent
{
    cardData: ICard;
    linkTags?: ITagLinkList;
}
export interface ICategoryListPage extends IReactComponent
{
    emptyList: IEmptyList;
    filterLayout: IFilterLayout;
    form: IForm;
    groups?: ICategoryListItem[];
    title?: string;
    pagination: IPagination;
    fetchFilteredResultsEndpoint: string;
}
export interface IChapterLink extends IReactComponent
{
    chapterNumber?: string;
    hasDash: boolean;
    link: ILink;
}
export interface IChapterNavigationList extends IReactComponent
{
    accordion: IAccordion;
    link: IChapterLink;
    linkOrLinkList: IChapterNavigationList_LinkOrLinkList[];
}
export interface IChapterNavigationList_LinkOrLinkList
{
    linkOrLinkList?: IChapterNavigationList;
    link?: IChapterLink;
}
export interface ICheckbox extends IReactComponent
{
    checked: boolean;
    label: string;
    name: string;
    value: string;
    dataId?: number;
}
export interface ICheckboxGroup extends IReactComponent
{
    title?: string;
    options: ICheckbox[];
    validationError?: string;
    required: boolean;
    requiredText: IMessage;
}
export interface IContactBlock extends IReactComponent
{
    items: IContentArea;
    onPageEditing?: IContactBlock_OnPageEditing;
    title: string;
    singleLink?: ILink;
    contactText?: IRichText;
}
export interface IContactBlock_OnPageEditing
{
    title: string;
}
export interface IContactInfo extends IReactComponent
{
    details: ILink[];
    onPageEditing?: IContactInfo_OnPageEditing;
    title: string;
    singleLink?: ILink;
}
export interface IContactInfo_OnPageEditing
{
    title: string;
}
export interface IContactList extends IReactComponent
{
    contactGroups: IContactListItem[];
}
export interface IContactListItem extends IReactComponent
{
    title: string;
    contactLists: IContactListItem_ContactLists[];
    contactText?: IRichText;
    onPageEditing?: IContactListItem_OnPageEditing;
}
export interface IContactListItem_ContactLists
{
    name: IContactListItem_ContactLists_Name;
    email?: ILink;
    phone?: ILink;
    contactUrl?: ILink;
}
export interface IContactListItem_ContactLists_Name
{
    text?: string;
    position?: string;
}
export interface IContactListItem_OnPageEditing
{
    title: string;
}
export interface IContentArea extends IReactComponent
{
    blocks: IContentAreaItem[];
    blockNotSupportedText?: string;
    onPageEditing?: IContentArea_OnPageEditing;
}
export interface IContentArea_OnPageEditing
{
    name: string;
}
export interface IContentAreaItem extends IReactComponent
{
    componentName: string;
    componentData: IReactComponent;
    id: string;
    onPageEditing?: IContentAreaItem_OnPageEditing;
    size: ContentAreaItem_Size;
}
export interface IContentAreaItem_OnPageEditing
{
    contentName: string;
    contentId: string;
}
export interface IContentAreaPage extends IReactComponent
{
    content: IContentArea;
    pageHeader?: IPageHeader;
    portfolioHeader?: IPortfolioHeader;
}
export interface IContentContainer extends IReactComponent
{
    onPageEditing?: IContentContainer_OnPageEditing;
}
export interface IContentContainer_OnPageEditing
{
    title: string;
}
export interface ICrmEmbedBlock extends IReactComponent
{
    src: string;
}
export interface ICtaLink extends IReactComponent
{
    image: IImage;
    text: string;
    url: string;
}
export interface IDataTagList extends IReactComponent
{
    list: string[];
}
export interface IDateCard extends IReactComponent
{
    dateContainer: IDateCardDates;
    messageList: IMessage[];
    metadata?: IMetadata;
    id: string;
    media?: IDateCardMedia;
    status?: IDateCardStatus;
    subtitle?: string;
    tags?: IDateCardTags;
    text?: string;
    title?: string;
    url: string;
    usedInSidebar: boolean;
    name?: string;
}
export interface IDateCardDates extends IReactComponent
{
    dates: IDateCardDates_Dates[];
    datesDescription?: string;
    datesTitle?: string;
    isPastDate: boolean;
    isInternational: boolean;
    isPlanned: boolean;
    className?: string;
    eventImage?: IEventImage;
    labels: IDateCardDates_Labels;
    moreDates?: IDatesMore;
    date?: string;
}
export interface IDateCardDates_Dates
{
    day: string;
    month: string;
    year: string;
}
export interface IDateCardDates_Labels
{
    pastDate: string;
}
export interface IDateCardMedia extends IReactComponent
{
    items: IDateCardMedia_Items[];
}
export interface IDateCardMedia_Items
{
    text: string;
    icon: DateCardMedia_Items_Icon;
    url: string;
}
export interface IDateCardStatus extends IReactComponent
{
    theme: DateCardStatus_Theme;
    text: string;
}
export interface IDateCardTags extends IReactComponent
{
    accordion?: IAccordion;
    items: ILink[];
    numberOfVisibleItems: number;
}
export interface IDatesMore extends IReactComponent
{
    accordion: IAccordion;
    title?: string;
    dates: IDatesMoreLink[];
}
export interface IDatesMoreLink extends IReactComponent
{
    link: ILink;
    tooltip?: IDatesMoreLink_Tooltip;
}
export interface IDatesMoreLink_Tooltip
{
    eventData: IEventData;
}
export interface IDescriptionListAndTables extends IReactComponent
{
    descriptionList?: IDescriptionListBlock;
    tables?: ITableBlock[];
}
export interface IDescriptionListBlock extends IReactComponent
{
    items?: IDescriptionListBlock_Items[];
    title?: string;
    headingLevel?: number;
}
export interface IDescriptionListBlock_Items
{
    label: string;
    text: string;
}
export interface IDocumentIcon extends IReactComponent
{
    iconTheme?: DocumentIcon_IconTheme;
    isRequired?: boolean;
    isBlack?: boolean;
}
export interface IDownloadList extends IReactComponent
{
    groups: IDownloadList_Groups[];
    downloadAllText?: string;
    downloadAllUrl?: string;
    requiredText?: string;
}
export interface IDownloadList_Groups
{
    heading?: string;
    subheading?: string;
    items: IDownloadList_Groups_Items[];
}
export interface IDownloadList_Groups_Items
{
    text: string;
    size: string;
    iconTheme: DocumentIcon_IconTheme;
    url: string;
    isRequired: boolean;
}
export interface IEducationBlock extends IReactComponent
{
    grade?: string;
    time?: string;
    link?: ILink;
    editorTheme: EducationBlock_EditorTheme;
    image?: IImage;
    onPageEditing?: IEducationBlock_OnPageEditing;
    imageLeft: boolean;
    title: string;
    ingress?: string;
}
export interface IEducationBlock_OnPageEditing
{
    title: string;
    ingress: string;
    time: string;
    grade: string;
}
export interface IEmbedBlock extends IReactComponent
{
    height?: number;
    onPageEditing?: string;
    src: string;
    title: string;
    width?: number;
}
export interface IEmployeeSearchResult extends IReactComponent
{
    labeledLinks: IEmployeeSearchResult_LabeledLinks[];
    subTitle?: string;
    title: string;
}
export interface IEmployeeSearchResult_LabeledLinks
{
    label: string;
    link: ILink;
}
export interface IEmptyList extends IReactComponent
{
    text: string;
}
export interface IErrorPage extends IReactComponent
{
    errorCode?: string;
    link?: ILink;
    title?: string;
    message?: string;
    search?: ISearch;
    text?: string;
    form: IForm;
}
export interface IEventCardList extends IReactComponent
{
    list: IEventCardList_List[];
}
export interface IEventCardList_List
{
    eventCard: ICard;
    moreDates?: IDatesMore;
    date?: string;
}
export interface IEventData extends IReactComponent
{
    items: IEventData_Items[];
    onPageEditing?: IEventData_OnPageEditing;
}
export interface IEventData_Items
{
    label: string;
    text: string[][];
}
export interface IEventData_OnPageEditing
{
    items: string;
}
export interface IEventImage extends IReactComponent
{
    image: IImage;
    background: EventImage_Background;
    darkFilter?: boolean;
    greyFilter?: boolean;
    isEvent?: boolean;
}
export interface IEventListItem extends IReactComponent
{
    eventCard: ICard;
    moreDates?: IDatesMore;
    date?: string;
}
export interface IEventListPage extends IReactComponent
{
    emptyList: IEmptyList;
    events: IEventListItem[];
    filterLayout: IFilterLayout;
    form: IForm;
    title?: string;
    topFilter: ITopFilter;
    fetchFilteredResultsEndpoint: string;
}
export interface IEventPage extends IReactComponent
{
    contactInfo?: IContentArea;
    labels: IEventPage_Labels;
    links?: IEventPageLink[];
    metadata: IEventData;
    onPageEditing?: IEventPage_OnPageEditing;
    speakers?: IContentArea;
    richText?: IRichText;
    registrationLink: ILink;
    schedule?: IContentArea;
    title?: string;
    share?: IOptionsModal;
    eventImage: IEventImage;
    media: IDateCardMedia;
    menu: IStickyMenuOnTabs;
    moreDates?: IDatesMore;
    date?: string;
    eventTag?: string;
}
export interface IEventPage_Labels
{
    about: ILabel;
    contact: ILabel;
    speakers: ILabel;
    schedule: ILabel;
}
export interface IEventPage_OnPageEditing
{
    title: string;
}
export interface IEventPageLink extends IReactComponent
{
    icon: EventPageLink_Icon;
    text: string;
    url: string;
}
export interface IFactBox extends IReactComponent
{
    accordion: IAccordion;
    onPageEditing?: IFactBox_OnPageEditing;
    title: string;
    text: IRichText;
}
export interface IFactBox_OnPageEditing
{
    title: string;
}
export interface IFilterGroup extends IReactComponent
{
    accordion: IAccordion;
    options: IFilterGroup_Options[];
    title?: string;
}
export interface IFilterGroup_Options
{
    checked: boolean;
    name: string;
    label: string;
    value: string;
    subOptions?: ICheckbox[];
}
export interface IFilterLayout extends IReactComponent
{
    contentArea?: IContentArea;
    filters?: IFilters;
    isLeft?: boolean;
}
export interface IFilters extends IReactComponent
{
    checkboxes?: ICheckbox[];
    items: IFilterGroup[];
    labels: IFilters_Labels;
    rangeFilter?: IRangeSlider;
    title?: string;
    mobileTitle: string;
}
export interface IFilters_Labels
{
    showResults?: string;
    reset: string;
    closeDialog: string;
}
export interface IFooter extends IReactComponent
{
    contactInfo?: IRichText;
    newsLetter?: ILink;
    linkLists: IFooter_LinkLists[];
    socialMedia: ISocialMediaLinkList;
    logo?: IFooter_Logo;
    about?: string;
    trademark?: string;
}
export interface IFooter_LinkLists
{
    id: number;
    title: string;
    links: ILink[];
    accordion: IAccordion;
}
export interface IFooter_Logo
{
    url: string;
    text: string;
    src: string;
}
export interface IForm extends IReactComponent
{
    endpoint: string;
    method?: string;
    submitButtonText: string;
}
export interface IFrontpage extends IReactComponent
{
    content: IContentArea;
    header?: IFrontpageHeader;
    linkList?: ILinkList;
}
export interface IFrontpageHeader extends IReactComponent
{
    image?: IImage;
    links: ILink[];
    onPageEditing?: IFrontpageHeader_OnPageEditing;
    title?: string;
    description?: string;
    editorTheme: FrontpageHeader_EditorTheme;
}
export interface IFrontpageHeader_OnPageEditing
{
    links: string;
    numbers: string;
    text: string;
}
export interface IGenericTextInputGroup extends IReactComponent
{
    title: string;
    options: IGenericTextInputGroup_Options[];
}
export interface IGenericTextInputGroup_Options
{
    name: string;
    label: string;
    value: string;
}
export interface IGlobalSearch extends IReactComponent
{
    closeButtonText: string;
    form: IForm;
    input: ITextInput;
    button: IButton;
    submitLabel: string;
    endpoint: string;
}
export interface IGroupedSearchPage extends IReactComponent
{
    emptyList: IEmptyList;
    filterLayout: IFilterLayout;
    form: IForm;
    navigation: IGroupedSearchPageLink[];
    sections: IGroupedSearchPageSectionFilterList;
    pagination: IPagination;
    results: ISearchResultGroup[];
    resultsDescription: string;
    search: ISearch;
    title?: string;
    fetchFilteredResultsEndpoint: string;
}
export interface IGroupedSearchPageLink extends IReactComponent
{
    isCurrent: boolean;
    link: ILink;
}
export interface IGroupedSearchPageSectionFilterList extends IReactComponent
{
    list: IGroupedSearchPageSectionFilterList_List[];
}
export interface IGroupedSearchPageSectionFilterList_List
{
    isCurrent: boolean;
    label: string;
    value: string;
    name: string;
    isDisabled: boolean;
    tooltip?: string;
}
export interface IHeader extends IReactComponent
{
    globalSearch: IGlobalSearch;
    linkToHome: ILink;
    linkList: ILink[];
    logo?: string;
    menu: IMenu;
    menuText: string;
    tabMenu: ITabMenu;
    priorityLink?: ILink;
    simpleHeader?: ISimpleHeader;
}
export interface IHtmlString extends IReactComponent
{
    onPageEditing?: IHtmlString_OnPageEditing;
    text: string;
}
export interface IHtmlString_OnPageEditing
{
    text: string;
}
export interface IIconWarning extends IReactComponent
{
    theme: IconWarning_Theme;
}
export interface IImage extends IReactComponent
{
    alt: string;
    focusPoint?: IImage_FocusPoint;
    onPageEditing?: IImage_OnPageEditing;
    src: string;
    dest: string;
    sizes: string;
    srcSet: string;
    isFluid?: boolean;
    responsive?: boolean;
    minWidth?: number;
    maxWidth?: number;
    aspectRatio?: number;
    initialSize?: number;
}
export interface IImage_FocusPoint
{
    x: number;
    y: number;
}
export interface IImage_OnPageEditing
{
    image: string;
}
export interface IImageBlock extends IReactComponent
{
    image: IImage;
    onPageEditing?: IImageBlock_OnPageEditing;
    title?: string;
}
export interface IImageBlock_OnPageEditing
{
    title: string;
}
export interface IImageWithCaption extends IReactComponent
{
    caption: string;
    editorTheme: ImageWithCaption_EditorTheme;
    image: IImage;
    fetchPriority: FetchPrioritySelector;
    onPageEditing?: IImageWithCaption_OnPageEditing;
    title?: string;
    isExternal: boolean;
}
export interface IImageWithCaption_OnPageEditing
{
    caption: string;
    title: string;
}
export interface IImageWithLink extends IReactComponent
{
    image: IImage;
    onPageEditing?: IImageWithLink_OnPageEditing;
    title?: string;
    text?: string;
    url: string;
    shareImageHeight: boolean;
    isProminent: boolean;
}
export interface IImageWithLink_OnPageEditing
{
    title: string;
    url: string;
    text: string;
}
export interface IInfoBlock extends IReactComponent
{
    includeIcon?: boolean;
    linkList?: ILinkList;
    onPageEditing?: IInfoBlock_OnPageEditing;
    title?: string;
    text?: IRichText;
    url?: ILink;
    cta?: ILink;
    icon?: IImage;
}
export interface IInfoBlock_OnPageEditing
{
    title: string;
}
export interface IInputEmail extends IReactComponent
{
    name: string;
    label: string;
    validationError: string;
    value: string;
}
export interface IKvinnehistorieMilestone extends IReactComponent
{
    year: string;
    title?: string;
    anchorId: string;
    intro?: string;
    body?: IRichText;
    image?: IImage;
    links?: ILinkList;
    hasMore: boolean;
    editUrl?: string;
    onPageEditing?: IKvinnehistorieMilestone_OnPageEditing;
}
export interface IKvinnehistorieMilestone_Labels
{
    showMore: string;
    showLess: string;
    edit: string;
    relatedLinks: string;
}
export interface IKvinnehistorieMilestone_OnPageEditing
{
    year: string;
    title: string;
    intro: string;
}
export interface IKvinnehistorieTimelinePage extends IReactComponent
{
    header?: IPageHeader;
    navigation: IKvinnehistorieTimelinePage_NavGroup[];
    scrubber: IKvinnehistorieTimelinePage_Scrubber;
    milestones: IKvinnehistorieMilestone[];
    activeAnchorId?: string;
    backToTimelineUrl?: string;
    labels: IKvinnehistorieTimelinePage_Labels;
    milestoneLabels: IKvinnehistorieMilestone_Labels;
}
export interface IKvinnehistorieTimelinePage_Labels
{
    heading: string;
    navAriaLabel: string;
    scrubberAriaLabel: string;
    decadeNavAriaLabel: string;
    previousDecade: string;
    nextDecade: string;
    scrubHandle: string;
    emptyHeading: string;
    emptyText: string;
    backToTimeline: string;
}
export interface IKvinnehistorieTimelinePage_Scrubber
{
    decades: IKvinnehistorieTimelinePage_NavItem[];
}
export interface IKvinnehistorieTimelinePage_NavGroup
{
    year: string;
    items: IKvinnehistorieTimelinePage_NavItem[];
}
export interface IKvinnehistorieTimelinePage_NavItem
{
    title?: string;
    anchorId: string;
}
export interface ILabel extends IReactComponent
{
    htmlId: string;
    title: string;
}
export interface ILargeArticlePage extends IReactComponent
{
    title?: string;
    image?: IImage;
    content: IRichText;
    header?: IArticleHeader;
    pageNavigation?: IPageNavigation;
    nestedMenu: INestedMenu;
    metadata?: IMetadataList;
    isFrontPage: boolean;
}
export interface ILargeDocumentsPage extends IReactComponent
{
    content: IRichText;
    header: IArticleHeader;
    ingress: string;
    pageNavigation?: IPageNavigation;
    tableOfContents: ITableOfContents;
    title?: string;
    contentArea: IContentArea;
}
export interface ILink extends IReactComponent
{
    id?: string;
    onPageEditing?: string;
    text?: string;
    url: string;
    trackUrl?: string;
    label?: string;
    isExternal?: boolean;
    isPrimary?: boolean;
    noFollow?: boolean;
    useSkinnyIcon?: boolean;
}
export interface ILinkList extends IReactComponent
{
    items?: ILink[];
    nestedLinks?: INestedLink_Item[];
    onPageEditing?: ILinkList_OnPageEditing;
}
export interface ILinkList_OnPageEditing
{
    items: string;
}
export interface ILinkListBlock extends IReactComponent
{
    htmlId?: string;
    links: ILinkList;
    title?: string;
}
export interface ILinkLists extends IReactComponent
{
    nestedLinks: INestedLink_Item[];
}
export interface ILinkWithText extends IReactComponent
{
    link: ILink;
    onPageEditing?: ILinkWithText_OnPageEditing;
    text: string;
    theme: LinkWithText_Theme;
}
export interface ILinkWithText_OnPageEditing
{
    link: string;
    text: string;
}
export interface ILinkWithTextList extends IReactComponent
{
    links: ILinkWithText[];
}
export interface IListItemImage extends IReactComponent
{
    image: IImage;
    size?: ListItemImage_Size;
}
export interface IMap extends IReactComponent
{
    googleMapsAPIKey: string;
    labels?: IMap_Labels;
    markers?: IMap_Markers[];
}
export interface IMap_Labels
{
    zoomIn: string;
    zoomOut: string;
}
export interface IMap_Markers
{
    name: string;
    latitude: number;
    longitude: number;
    popup: IMapPopup;
}
export interface IMapPopup extends IReactComponent
{
    address: IRichText;
    link: ILink;
    title?: string;
}
export interface IMediaBlock extends IReactComponent
{
    title?: string;
    onPageEditing?: IMediaBlock_OnPageEditing;
    youTubeVideo?: IYoutubeVideo;
    embed?: IEmbedBlock;
    image?: IImage;
    link?: ILink;
    icon?: IImage;
    caption?: string;
}
export interface IMediaBlock_OnPageEditing
{
    title: string;
    caption: string;
}
export interface IMenu extends IReactComponent
{
    id: string;
    closeButtonText: string;
    globalSearch?: IGlobalSearch;
    headerLinkList?: ILink[];
    navigationGroups: INavigationGroup[];
}
export interface IMenuSearch extends IReactComponent
{
    form: IForm;
    input: ISearchInput;
    submitLabel: string;
}
export interface IMessage extends IReactComponent
{
    text: IHtmlString;
    theme: IconWarning_Theme;
}
export interface IMessageCarousel extends IReactComponent
{
    messageGlobals: IMessageGlobal[];
    initiallyOpen?: boolean;
}
export interface IMessageGlobal extends IReactComponent
{
    id: string;
    message: IHtmlString;
    labels: IMessageGlobal_Labels;
    title: string;
    theme: IconWarning_Theme;
}
export interface IMessageGlobal_Labels
{
    show: string;
    hide: string;
    of: string;
}
export interface IMessageGlobalList extends IReactComponent
{
    messageGlobals?: IMessageGlobal[];
    initiallyOpen: boolean;
    prefix?: string;
    printDescription?: string;
    defaultPrintMessage: string;
}
export interface IMetadata extends IReactComponent
{
    items: IMetadata_Items[];
}
export interface IMetadata_Items
{
    label: string;
    text: string;
    url?: string;
    isDisabled: boolean;
}
export interface IMetadataList extends IReactComponent
{
    title: string;
    items: IMetadataList_Items[];
}
export interface IMetadataList_Items
{
    label: string;
    text: string[];
}
export interface INavigationGroup extends IReactComponent
{
    items: INavigationGroup_Items[];
    title?: string;
}
export interface INavigationGroup_Items
{
    link?: ILink;
    linkList?: INavigationList;
}
export interface INavigationList extends IReactComponent
{
    accordion: IAccordion;
    title: string;
    linkList: ILinkList;
}
export interface INestedLink extends IReactComponent
{
    item: INestedLink_Item;
}
export interface INestedLink_Item
{
    icon?: string;
    id?: string;
    onPageEditing?: string;
    text: string;
    url: string;
    label?: string;
    title?: string;
    items?: ILink[];
    isSmall: boolean;
}
export interface INestedMenu extends IReactComponent
{
    accordion: IAccordion;
    title?: string;
    linkList: INestedMenu_LinkList[];
    linkLists: INestedMenu_LinkLists[];
    mainPageLink?: ILink;
}
export interface INestedMenu_LinkList
{
    link: ILink;
    isCurrent: boolean;
}
export interface INestedMenu_LinkLists
{
    accordion: IAccordion;
    isCurrent: boolean;
    linkList: INestedMenu_LinkLists_LinkList[];
    section: INestedMenu_LinkLists_Section;
}
export interface INestedMenu_LinkLists_LinkList
{
    link: ILink;
    isCurrent: boolean;
}
export interface INestedMenu_LinkLists_Section
{
    number: string;
    title: string;
}
export interface INewsletterAdministrationLayout extends IReactComponent
{
    header: ISimpleHeader;
}
export interface INewsletterAdminPage extends IReactComponent
{
    checkboxGroups?: ICheckboxGroup[];
    form: IForm;
    inputFieldsTitle?: string;
    inputFieldsItems?: ITextInput[];
    layout: INewsletterAdministrationLayout;
    submitButton: IButton;
    title?: string;
    unsubscribeLink: ILink;
    validation?: IValidation;
}
export interface INewsletterCrmRegistrationPage extends IReactComponent
{
    registrationPage: INewsletterRegistrationPage;
}
export interface INewsletterRegistrationPage extends IReactComponent
{
    checkboxGroups?: ICheckboxGroup[];
    genericTextInputGroup?: IGenericTextInputGroup;
    footer: IPageFooter;
    form: IForm;
    inputTitle?: string;
    inputFields?: IInputEmail[];
    richText: IRichText;
    sidebar: IContentArea;
    submitButton: IButton;
    title?: string;
    htmlString?: string;
}
export interface INewsletterUnsubscribeConfirmationPage extends IReactComponent
{
    layout: INewsletterAdministrationLayout;
    title?: string;
    text: string;
}
export interface INewsletterUnsubscribePage extends IReactComponent
{
    form: IForm;
    input: ITextInput;
    layout: INewsletterAdministrationLayout;
    submitButton: IButton;
    title?: string;
}
export interface INewsletterUpdatedPage extends IReactComponent
{
    categoriesTitle?: string;
    categoriesList: INewsletterUpdatedPage_CategoriesList[];
    emailTitle?: string;
    emailText?: string;
    layout: INewsletterAdministrationLayout;
    title?: string;
}
export interface INewsletterUpdatedPage_CategoriesList
{
    name: string;
    description: string;
}
export interface INpMethod extends IReactComponent
{
    title?: string;
    ingress: string;
    link: ILink;
    menu: IStep[];
    stepsContent: IStepsContent;
}
export interface INumberBlock extends IReactComponent
{
    description: string;
    number: string;
    onPageEditing?: INumberBlock_OnPageEditing;
    text?: string;
    url: string;
    link?: INumberBlock_Link;
}
export interface INumberBlock_OnPageEditing
{
    description: string;
    number: string;
    text: string;
    url: string;
}
export interface INumberBlock_Link
{
    text?: string;
    url: string;
}
export interface INumberListBlock extends IReactComponent
{
    numbers: INumberBlock[];
}
export interface IOfficeBlock extends IReactComponent
{
    info: IOfficeBlockInfo[];
    title?: string;
}
export interface IOfficeBlockInfo extends IReactComponent
{
    link?: ILink;
    moreText?: string;
    text?: string;
    title?: string;
}
export interface IOfficeListBlock extends IReactComponent
{
    links: IOfficeListBlock_Links[];
    selector: ITabsMobile;
    offices: IContentArea;
}
export interface IOfficeListBlock_Links
{
    id: string;
    isActive: boolean;
    link: ILink;
}
export interface IOptionsModal extends IReactComponent
{
    shareContent?: IShareOptions;
    downloadContent?: IDownloadList;
    openButtonText: string;
    closeButtonLabel: string;
}
export interface IPageFooter extends IReactComponent
{
    byline: IByline;
    download?: ILink;
    share?: IOptionsModal;
}
export interface IPageHeader extends IReactComponent
{
    image?: IImage;
    ingress?: string;
    links?: ILink[];
    portfolioLinks?: ILink[];
    map?: IMap;
    title?: string;
    tags?: ITags;
    onPageEditing?: IPageHeader_OnPageEditing;
}
export interface IPageHeader_OnPageEditing
{
    title: string;
    ingress: string;
    links: string;
}
export interface IPageLinksBlock extends IReactComponent
{
    highlightedLinks?: IContentArea;
    linkLists: IPageLinksBlock_LinkLists[];
    onPageEditing?: IPageLinksBlock_OnPageEditing;
    text?: string;
    title?: string;
}
export interface IPageLinksBlock_LinkLists
{
    id: string;
    links: IContentArea;
}
export interface IPageLinksBlock_OnPageEditing
{
    text: string;
    title: string;
}
export interface IPageNavigation extends IReactComponent
{
    previous?: ILink;
    next?: ILink;
}
export interface IPagination extends IReactComponent
{
    pages?: IPagination_Pages[];
    title?: string;
}
export interface IPagination_Pages
{
    isCurrent: boolean;
    label: string;
    link: ILink;
}
export interface IPartnerLogoBlock extends IReactComponent
{
    items: IContentArea;
    onPageEditing?: IPartnerLogoBlock_OnPageEditing;
    title?: string;
}
export interface IPartnerLogoBlock_OnPageEditing
{
    title: string;
}
export interface IPersonBlock extends IReactComponent
{
    company: string;
    image?: IImage;
    jobTitle: string;
    name?: string;
    onPageEditing?: IPersonBlock_OnPageEditing;
    text: string;
}
export interface IPersonBlock_OnPageEditing
{
    company: string;
    jobTitle: string;
    name: string;
    text: string;
}
export interface IPortfolioContent extends IReactComponent
{
    title?: string;
    text?: string;
    content?: IContentArea;
    isInsidePriorityBlock: boolean;
    singleColumn: boolean;
    emptyListText?: string;
    sectionTitleLinks?: IPortfolioContent_SectionTitleLinks[];
}
export interface IPortfolioContent_SectionTitleLinks
{
    text: string;
    url: string;
}
export interface IPortfolioHeader extends IReactComponent
{
    image: IImage;
    links?: ILink[];
    onPageEditing?: IPortfolioHeader_OnPageEditing;
    title?: string;
    description?: string;
}
export interface IPortfolioHeader_OnPageEditing
{
    links: string;
    numbers: string;
    text: string;
}
export interface IPortfolioTile extends IReactComponent
{
    theme: PortfolioTile_Theme;
}
export interface IPortfolioTiles extends IReactComponent
{
    tiles: IPortfolioTiles_Tiles[];
}
export interface IPortfolioTiles_Tiles
{
    link: ILink;
    theme: PortfolioTile_Theme;
}
export interface IProcess extends IReactComponent
{
    title?: string;
    introText?: string;
    isCarousel: boolean;
    items: IProcessItem[];
    labels: IProcessCarousel_Labels;
}
export interface IProcessCarousel extends IReactComponent
{
    items: IProcessItem[];
    labels: IProcessCarousel_Labels;
}
export interface IProcessCarousel_Labels
{
    next: string;
    previous: string;
}
export interface IProcessItem extends IReactComponent
{
    icon?: IImage;
    text?: string;
    url?: string;
    title?: string;
}
export interface IProposal extends IReactComponent
{
    id: string;
    dateLabel: string;
    date: string;
    mobileDate: string;
    year: string;
    metadata?: IMetadata;
    status: IStatus;
    tags?: ITags;
    text: string;
    title: string;
    url: string;
    isInternational: boolean;
    messageList?: IMessage[];
    applicationSystemTag?: string;
    groupTag?: string;
}
export interface IProposalCardList extends IReactComponent
{
    proposals: IProposal[];
}
export interface IProposalContact extends IContactInfo
{
}
export interface IProposalData extends IReactComponent
{
    items: IProposalData_Items[];
}
export interface IProposalData_Items
{
    label: string;
    text?: string;
    links: ILink[];
}
export interface IProposalGroup extends IReactComponent
{
    accordion: IAccordion;
    headerAccordion: IAccordion;
    numberOfVisibleItems: number;
    proposals: IProposal[];
    subtitle: string;
    text: IRichText;
    title?: string;
}
export interface IProposalListPage extends IReactComponent
{
    emptyList: IEmptyList;
    filterLayout: IFilterLayout;
    form: IForm;
    groups: IProposalGroup[];
    title?: string;
    topFilter: ITopFilter;
    sectionTitle?: string;
    fetchFilteredResultsEndpoint: string;
    proposalShortcuts?: IProposalShortcuts;
    description: string;
}
export interface IProposalPage extends IReactComponent
{
    applyButton: ILink;
    contact?: IProposalContact;
    contactLabel: string;
    download?: IOptionsModal;
    header?: IArticleHeader;
    metadataLeft: IProposalData;
    metadataRight: IProposalData;
    message?: IMessage;
    descriptionTitle?: string;
    descriptionText: IRichText;
    descriptionIngress?: string;
    tabs?: ITabs;
    timelineHorizontal?: ITimelineHorizontal;
    title?: string;
    isInternational: boolean;
    share?: IOptionsModal;
    statusList?: IDateCardStatus[];
    timelineVertical?: ITimelineVertical;
}
export interface IProposalShortcuts extends IReactComponent
{
    title?: string;
    items?: IProposalShortcuts_Items[];
    initiallyOpenUrls?: string[];
    accordion: IAccordion;
}
export interface IProposalShortcuts_Items
{
    title: string;
    articleTitle: string;
    image: IImage;
    text: string;
    link: ILink;
    status: string;
    moreDates: IDatesMore;
}
export interface IPublicationsPage extends IGroupedSearchPage
{
}
export interface IPublished extends IReactComponent
{
    type: string;
    date: string;
}
export interface IQuote extends IReactComponent
{
    onPageEditing?: IQuote_OnPageEditing;
    text: string;
    quoteBy: string;
}
export interface IQuote_OnPageEditing
{
    text: string;
    quoteBy: string;
}
export interface IQuotesBlock extends IReactComponent
{
    title?: string;
    quotes: IQuotesBlock_Quotes[];
}
export interface IQuotesBlock_Quotes
{
    image?: IImage;
    quotee?: string;
    text: string;
    addQuoteDash: boolean;
}
export interface IRangeSlider extends IReactComponent
{
    from: ITextInput;
    label: string;
    max: number;
    min: number;
    submit: IButton;
    to: ITextInput;
}
export interface IReactComponent
{
}
export interface IRecord extends IReactComponent
{
    date: string;
    richText: IRichText;
}
export interface IRelatedArticles extends IReactComponent
{
    articles: IArticleBlock[];
    relatedContent: IRelatedContent;
    usedInSidebar?: boolean;
    isGrid?: boolean;
    isPublication?: boolean;
}
export interface IRelatedContent extends IReactComponent
{
    emptyList: IEmptyList;
    link?: ILink;
    onPageEditing?: IRelatedContent_OnPageEditing;
    title?: string;
    border?: RelatedContent_Border;
}
export interface IRelatedContent_OnPageEditing
{
    title: string;
}
export interface IRelatedDates extends IReactComponent
{
    dates: IDateCard[];
    relatedContent: IRelatedContent;
    usedInSidebar?: boolean;
    isGrid?: boolean;
}
export interface IRelatedPublications extends IReactComponent
{
    relatedContent: IRelatedContent;
    publications: ISearchResult[];
    usedInSidebar?: boolean;
}
export interface IResponsiveIframe extends IReactComponent
{
    src: string;
    title: string;
}
export interface IResponsiveIframePage extends IReactComponent
{
    footer: IPageFooter;
    iframe: IResponsiveIframe;
    richText: IRichText;
    sidebar: IContentArea;
    title?: string;
}
export interface IRichText extends IContentArea
{
}
export interface IRichTextBlock extends IReactComponent
{
    text: IRichText;
}
export interface IRichTextWithTitle extends IReactComponent
{
    headingLevel?: number;
    headingLevelOffset?: number;
    htmlId?: string;
    text: IRichText;
    title?: string;
}
export interface IRss extends IReactComponent
{
    headerText: string;
    buttonText: string;
    info?: IRichText;
    url: string;
}
export interface ISatelliteFrontpage extends IReactComponent
{
    satelliteHeader: IFrontpageHeader;
    content: IContentArea;
}
export interface ISatelliteHeader extends IReactComponent
{
    image?: IImage;
    ingress?: string;
    links: ILink[];
    map?: IMap;
    onPageEditing?: ISatelliteHeader_OnPageEditing;
    title?: string;
    text?: string;
    textColor: SatelliteHeader_TextColor;
}
export interface ISatelliteHeader_OnPageEditing
{
    title: string;
    ingress: string;
    text: string;
    links: string;
}
export interface ISchedule extends IReactComponent
{
    programList: ISchedule_ProgramList[];
    lastTitle?: string;
    onPageEditing?: ISchedule_OnPageEditing;
}
export interface ISchedule_ProgramList
{
    time: string;
    title?: string;
    text: IRichText;
    isBreak?: boolean;
}
export interface ISchedule_OnPageEditing
{
    programList?: string;
}
export interface IScreen9 extends IReactComponent
{
    embed: string;
}
export interface ISearch extends IReactComponent
{
    externalResultsLabel: string;
    externalResultsEndpoint: string;
    input: ITextInput;
    resultsDescription?: string;
    submit: IButton;
    searchSuggestions?: ISearchSuggestions;
}
export interface ISearchInput extends ITextInput
{
}
export interface ISearchPage extends IReactComponent
{
    emptyList: IEmptyList;
    filterLayout: IFilterLayout;
    form: IForm;
    pagination: IPagination;
    results: ISearchResult[];
    resultDescription: string;
    search: ISearch;
    title?: string;
    fetchFilteredResultsEndpoint: string;
}
export interface ISearchResult extends IReactComponent
{
    text?: string;
    title: string;
    metadata?: IMetadata;
    url: string;
    trackUrl: string;
    image?: IImage;
    icon?: IDocumentIcon;
    statusList?: IDateCardStatus[];
    themeTags?: IDateCardTags;
    descriptiveTitle?: string;
}
export interface ISearchResultGroup extends IReactComponent
{
    htmlId?: string;
    results: IContentArea;
    title?: string;
    iconName: SearchResultGroup_IconName;
}
export interface ISearchSuggestions extends IReactComponent
{
    label: string;
    suggestions: string[];
}
export interface IShareOptions extends IReactComponent
{
    items: IShareOptions_Items[];
}
export interface IShareOptions_Items
{
    text: string;
    url: string;
    icon: ShareOptions_Items_Icon;
}
export interface ISimpleHeader extends IReactComponent
{
    url: string;
}
export interface ISimpleTabContentSection extends IReactComponent
{
    sectionTitle?: string;
    sectionText?: IRichText;
    htmlId?: string;
    subSections?: IRichTextWithTitle[];
}
export interface ISocialMediaLink extends IReactComponent
{
    provider: SocialMediaLink_Provider;
    url: string;
    text: string;
}
export interface ISocialMediaLinkList extends IReactComponent
{
    items: ISocialMediaLink[];
}
export interface IStatsLink extends IReactComponent
{
    image: IImage;
    title: string;
    link: ILink;
}
export interface IStatsLinkList extends IReactComponent
{
    heading: string;
    statsLinks: IStatsLink[];
    aboutImage: IImage;
    seeMoreLink?: ILink;
}
export interface IStatus extends IReactComponent
{
    theme?: Status_Theme;
    text: string;
}
export interface IStatusPage extends IReactComponent
{
    title: string;
    serviceStatus: IStatusPage_ServiceStatus[];
    statusMessage?: IMessage;
    rss?: IRss;
    icons?: IStatusPage_Icons[];
    onPageEditing?: IStatusPage_OnPageEditing;
}
export interface IStatusPage_ServiceStatus
{
    title: string;
    description: string;
    icon: string;
}
export interface IStatusPage_Icons
{
    title: string;
    name: string;
}
export interface IStatusPage_OnPageEditing
{
    title: string;
}
export interface IStep extends IReactComponent
{
    text: string;
    isActive: boolean;
}
export interface IStepsBlock extends IReactComponent
{
    pages: IStepsBlock_Pages[];
}
export interface IStepsBlock_Pages
{
    title: string;
    text: string;
    buttonText: string;
    image: IImage;
}
export interface IStepsContent extends IReactComponent
{
    close: IStepsContent_Close;
    activeStepIndex: number;
    steps: IStepsContent_Steps[];
}
export interface IStepsContent_Close
{
    textMobile: string;
    textDesktop: string;
}
export interface IStepsContent_Steps
{
    videoBlock?: IVideoBlock;
    stepsBlock?: IStepsBlock;
    quotesBlock?: IQuotesBlock;
}
export interface IStickyMenuOnTabs extends IReactComponent
{
    navGroups: IStickyMenuOnTabs_NavGroups[];
    title?: string;
}
export interface IStickyMenuOnTabs_NavGroups
{
    titleLink?: ILink;
    links?: IStickyMenuOnTabs_NavGroups_Links;
}
export interface IStickyMenuOnTabs_NavGroups_Links
{
    items: IStickyMenuOnTabsItem[];
}
export interface IStickyMenuOnTabsItem extends IReactComponent
{
    link: IStickyMenuOnTabsItem_Link;
}
export interface IStickyMenuOnTabsItem_Link
{
    text: string;
    url: string;
}
export interface ITabContent extends IReactComponent
{
    contentSections?: ITabContentSection[];
    menu?: IStickyMenuOnTabs;
}
export interface ITabContentSection extends IReactComponent
{
    content?: IContentArea;
    contentDescription?: IRichTextWithTitle;
    downloadList?: IDownloadList;
    ingress?: IRichText;
    moreContent?: IContentArea;
    moreTexts: IRichTextWithTitle[];
    title?: string;
    texts: IRichTextWithTitle[];
    process?: IProcess;
    htmlId: string;
    application?: ITabContentSection_Application;
}
export interface ITabContentSection_Application
{
    title: string;
    text: string;
    link: ILink;
}
export interface ITabContentWrapper extends IReactComponent
{
    tibi: ITibiTabContent;
    evurdering: ITabContent;
}
export interface ITable extends IReactComponent
{
    title: string;
    header: string[];
    rows: ITable_Rows[][];
    isSortingEnabled?: boolean;
    sortingIndex?: number;
}
export interface ITable_Rows
{
    value: string;
    displayValue?: string;
    isRightAligned?: boolean;
}
export interface ITableBlock extends IReactComponent
{
    table: ITable;
    title: string;
    richText?: IRichText;
    mobileList?: ITableMobile;
}
export interface ITableMobile extends IReactComponent
{
    items: ITableMobileItem[];
    sortMenu: ITableMobileSort;
}
export interface ITableMobileItem extends IReactComponent
{
    list: ITableMobileItem_List[];
    accordion: IAccordion;
}
export interface ITableMobileItem_List
{
    label: string;
    value: string;
    displayValue?: string;
}
export interface ITableMobileSort extends IReactComponent
{
    accordion: IAccordion;
    title: string;
}
export interface ITableOfContents extends IReactComponent
{
    items: ITableOfContents_Items[];
    title: string;
    accordion: IAccordion;
}
export interface ITableOfContents_Items
{
    link?: IChapterLink;
    linkOrLinkList?: IChapterNavigationList;
}
export interface ITabMenu extends IReactComponent
{
    mainContentLink: ILink;
    filtersLink: ILink;
    openMenuLabel: string;
}
export interface ITabs extends IReactComponent
{
    activeTab?: string;
    items: ITabs_Items[];
}
export interface ITabs_Items
{
    guid: string;
    content: ITabContentWrapper;
    name: string;
}
export interface ITabsMobile extends IReactComponent
{
    title: string;
    accordion: IAccordion;
    tabs?: ITabsMobileTab[];
}
export interface ITabsMobileTab
{
    id: string;
    isActive: boolean;
    link: ILink;
}
export interface ITagLinkList extends IReactComponent
{
    leftAligned?: boolean;
    tags: ITagLinkList_Tags[];
}
export interface ITagLinkList_Tags
{
    link: ILink;
    inactive: boolean;
}
export interface ITagList extends IReactComponent
{
    tags: ITagList_Tags[];
}
export interface ITagList_Tags
{
    text: string;
}
export interface ITags extends IReactComponent
{
    list: string[];
}
export interface ITextInput extends IReactComponent
{
    label?: string;
    name: string;
    placeholder?: string;
    validationError?: string;
    value?: string;
    dataId?: number;
}
export interface ITextWithSidebar extends IReactComponent
{
    sidebar: IContentArea;
    text: IRichText;
    title?: string;
    htmlId: string;
    headingLevel?: number;
    share?: IOptionsModal;
}
export interface ITibiProposalData extends IReactComponent
{
    items: IProposalData_Items[];
    contacts?: IProposalContact[];
    contactLabel: string;
    arbitrary?: boolean;
    rightColumn?: boolean;
}
export interface ITibiProposalPage extends IReactComponent
{
    applyButton: ILink;
    contacts: IProposalContact[];
    contactLabel: string;
    download?: IOptionsModal;
    header?: IArticleHeader;
    metaDataTitle?: string;
    metadataLeft: ITibiProposalData;
    metadataRight: ITibiProposalData;
    arbitraryMetadata?: ITibiProposalData;
    message?: IMessage;
    tabs?: ITabs;
    timelineHorizontal?: ITimelineHorizontal;
    headerContentArea: IContentArea;
    footerContentArea: IContentArea;
    applicationSystemTag?: string;
    title?: string;
    preamble?: IRichText;
    isInternational?: boolean;
    statusList?: IDateCardStatus[];
    timelineVertical: ITimelineVertical;
    siblings?: IAnnouncement;
    goBack?: ILink;
}
export interface ITibiTabContent extends IReactComponent
{
    menuTitle: string;
    contentSections: ISimpleTabContentSection[];
}
export interface ITimelineHorizontal extends IReactComponent
{
    labels: ITimelineHorizontal_Labels;
    items: ITimelineItem[];
    startIndex?: number;
    title?: string;
}
export interface ITimelineHorizontal_Labels
{
    next?: string;
    previous?: string;
}
export interface ITimelineHorizontalBlock extends ITimelineHorizontal
{
}
export interface ITimelineItem extends IReactComponent
{
    isPastDate: boolean;
    subTitle?: string;
    text: IRichText;
    title?: string;
    progress?: number;
}
export interface ITimelineVertical extends IReactComponent
{
    title?: string;
    records: IRecord[];
    numberOfVisibleRecords: number;
    accordion: IAccordion;
    onPageEditing?: ITimelineVertical_OnPageEditing;
}
export interface ITimelineVertical_OnPageEditing
{
    title: string;
    records: string;
}
export interface ITopFilter extends IReactComponent
{
    options: ITopFilter_Options[];
    title: string;
    timeframe: ITopFilter_Timeframe;
}
export interface ITopFilter_Options
{
    isCurrent: boolean;
    disabled: boolean;
    link: ILink;
}
export interface ITopFilter_Timeframe
{
    value: number;
    id: string;
    name: string;
}
export interface IVacancies extends IReactComponent
{
    emptyList: IEmptyList;
    items: IVacancy[];
    link: ILink;
    title?: string;
    text: string;
}
export interface IVacancy extends IReactComponent
{
    id: string;
    dateLabel: string;
    date: string;
    mobileDate: string;
    year: string;
    metadata?: IMetadata;
    status?: IStatus;
    text: string;
    title: string;
    url: string;
    headingLevel?: number;
}
export interface IValidation extends IReactComponent
{
    message: string;
    fields: string[];
}
export interface IVideoBlock extends IReactComponent
{
    video: IYoutubeVideo;
    step: string;
    title: string;
    text: string;
    playText: string;
}
export interface IYoutubeVideo extends IReactComponent
{
    onPageEditing?: string;
    urlOrEmbed: string;
}
